import { logEvent } from "firebase/analytics";
import { getAnalyticsInstance } from '../firebase/config';

// Firebase Analyticsを初期化（既存のFirebase設定を使用）
export const initializeAnalytics = async () => {
  // firebase/config.jsで既に初期化済みのため、何もしない
  console.log('Analytics initialization delegated to firebase/config');
};

// ページビューを追跡
export const trackPageView = (pageName) => {
  const analytics = getAnalyticsInstance();
  if (analytics) {
    logEvent(analytics, 'page_view', { 
      page_title: pageName,
      page_location: window.location.href,
      page_path: window.location.pathname + window.location.search
    });
    console.log(`Page view tracked: ${pageName}`);
  }
};

// カスタムイベントを追跡
export const trackEvent = (eventName, parameters = {}) => {
  const analytics = getAnalyticsInstance();
  if (analytics) {
    // 個人情報を含む可能性のあるパラメータを除去
    const sanitizedParams = {};
    Object.keys(parameters).forEach(key => {
      const value = parameters[key];
      // 簡単なPII除去（UUID形式の文字列をマスク）
      if (typeof value === 'string' && value.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
        sanitizedParams[key] = '***MASKED***';
      } else {
        sanitizedParams[key] = value;
      }
    });
    
    logEvent(analytics, eventName, sanitizedParams);
    console.log(`Event tracked: ${eventName}`, sanitizedParams);
  }
};

// Analyticsが利用可能かチェック
export const isAnalyticsAvailable = () => {
  const analytics = getAnalyticsInstance();
  return analytics !== null;
};